import React from "react";
import dd1 from "../../../assets/images/visa/dd1.webp";
import dd2 from "../../../assets/images/visa/dd2.png";
import dd3 from "../../../assets/images/visa/dd3.webp";
import dc1 from "../../../assets/images/visa/dc1.webp";
import dc2 from "../../../assets/images/visa/dc2.webp";
import dc3 from "../../../assets/images/visa/dc3.webp";
import { Animate, Stagger } from "../../animations";

function DreamDestination() {
  const cardsData = [
    {
      img: dd1,
      detailImage: dc1,
      destination: "Study in Canada",
      description:
        "Don't miss your chance to study and settle in one of the most livable countries of the world with 223 Universities and 750,000+ International Students",
    },
    {
      img: dd2,
      detailImage: dc2,
      destination: "Study in Australia",
      description:
        "Explore high-quality education, vibrant cities, and stunning landscapes in one of the top study destinations for international students.",
    },
    {
      img: dd3,
      detailImage: dc3,
      destination: "Study in USA",
      description:
        "Pursue your academic goals in the land of opportunities with world-class universities, diverse cultures, and unparalleled opportunities.",
    },
  ];

  return (
    <section className="layout-section">
      <div className="layout-container">
        <Animate variant="fadeUp">
          <h1 id="heading-large" className="text-center mb-8">
            Select Your Dream Destination
          </h1>
        </Animate>
        <Stagger
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full"
          variant="fadeUp"
          stagger={120}
        >
          {cardsData.map((card, index) => (
            <div
              key={index}
              className="rounded-md shadow-lg bg-white overflow-hidden flex flex-col anim-hover-lift"
            >
              <div className="relative">
                <img
                  src={card.img}
                  alt={card.destination}
                  className="h-48 w-full object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-white/90 px-3 py-2 flex items-center gap-2">
                  <img
                    src={card.detailImage}
                    alt=""
                    className="w-8 h-8 rounded object-cover flex-shrink-0"
                  />
                  <h4 className="font-bold text-gray-700 text-sm">{card.destination}</h4>
                </div>
              </div>
              <p id="dark" className="p-4 text-justify text-sm text-gray-600 flex-grow">
                {card.description}
              </p>
              <button type="button" className="px-4 pb-4 text-left text-blue-600 hover:underline text-sm">
                Read More
              </button>
            </div>
          ))}
        </Stagger>
      </div>
    </section>
  );
}

export default DreamDestination;
